import moment from 'moment';
import { VOUCHER_DESCRIPTION, DISCOUNT } from './constant';

export const buildGetVouchersQuery = ({ currency }) => ({
  fromDate: moment().startOf('month').format('YYYY-MM-DD'),
  toDate: moment().endOf('month').format('YYYY-MM-DD'),
  active: true,
  description: VOUCHER_DESCRIPTION.SILVER_DISCOUNT,
  voucherType: DISCOUNT,
  convertTotalToCurrency: currency
});
